"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));
var TextField_1 = __importDefault(require("@material-ui/core/TextField"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox"));
var ory_editor_ui_1 = require("ory-editor-ui");
var ory_editor_ui_2 = require("ory-editor-ui");
var ThemeProvider_1 = __importStar(require("ory-editor-ui/lib/ThemeProvider"));
var ImageDefaultControls = function (props) {
    var Renderer = props.Renderer, handleImageLoaded = props.handleImageLoaded, handleImageUploaded = props.handleImageUploaded, handleChange = props.handleChange, readOnly = props.readOnly, focused = props.focused;
    return (React.createElement("div", null,
        React.createElement(Renderer, __assign({}, props, { imagePreview: props.imagePreview })),
        !readOnly && focused && React.createElement(ThemeProvider_1.default, { theme: ThemeProvider_1.darkTheme },
            React.createElement(ory_editor_ui_2.BottomToolbar, { open: props.focused, theme: ThemeProvider_1.darkTheme },
                React.createElement("div", { style: { display: 'flex' } },
                    props.imageUpload && (React.createElement(React.Fragment, null,
                        React.createElement(ory_editor_ui_1.ImageUpload, { imageUpload: props.imageUpload, imageLoaded: handleImageLoaded, imageUploaded: handleImageUploaded }),
                        React.createElement(Typography_1.default, { variant: "body1", style: { marginLeft: '20px', marginRight: '20px' } }, "OR"))),
                    React.createElement(TextField_1.default, { placeholder: "http://example.com/image.png", label: props.imageUpload ? 'I have a URL' : 'Image URL', name: "src", style: { flex: 1 }, value: props.state.src, onChange: handleChange })),
                React.createElement(TextField_1.default, { placeholder: "http://example.com", label: "Link location (url)", name: "href", style: { width: '512px' }, value: props.state.href, onChange: handleChange }),
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement(FormControlLabel_1.default, { control: React.createElement(Checkbox_1.default, { checked: props.state.target === '_blank', name: "target", onChange: handleChange }), label: "Open in new window" })))));
};
exports.default = ImageDefaultControls;
//# sourceMappingURL=ImageDefaultControls.js.map